<template>
  <div class="c-navbar__links">
    <router-link class="c-navbar__button c-sidenav__item--games btn-default" to="/games" data-test="navbar-games"><svg class="c-navbar__button-icon icon icon-ghost icon-green"><use xlink:href="#icon-ghost"></use></svg> {{ $speak('games_button') }}</router-link>
    <router-link class="c-navbar__button c-sidenav__item--offers btn-default" to="/offers" data-test="navbar-offers"><svg class="c-navbar__button-icon icon icon-gift icon-pink"><use xlink:href="#icon-gift"></use></svg> {{ $speak('offers_button') }}</router-link>
    <router-link class="c-navbar__button c-sidenav__item--casinos btn-default" to="/casinos" data-test="navbar-casinos"><svg class="c-navbar__button-icon icon icon-crown icon-orange"><use xlink:href="#icon-crown"></use></svg> {{ $speak('casino_button') }}</router-link>
    <router-link class="c-navbar__button c-sidenav__item--city btn-default" to="/city" data-test="navbar-city"><svg class="c-navbar__button-icon icon icon-marker icon-teal"><use xlink:href="#icon-marker"></use></svg> {{ $speak('map_button') }}</router-link>
    <router-link class="c-navbar__button c-sidenav__item--news btn-default" to="/news" data-test="navbar-news"><svg class="c-navbar__button-icon icon icon-speaker icon-purple-lighter"><use xlink:href="#icon-speaker"></use></svg> {{ $speak('news_button') }}</router-link>
  </div>
</template>

<script>
  // Vuex
  import { mapActions, mapGetters } from 'vuex';
  
  export default {
    name: 'NavBarLinks',
    
    speak: {
      prefix: 'app.components.NavBarLinks'
    },

    data () {
      return {
        alignFavourites: 'c-dropnav--align-top',
      }
    },

    computed: {
      ...mapGetters([
        'user'
      ])
    },

    methods: {

    },

    created () {
      if (this.$mq('sm-max')) this.alignFavourites = 'c-dropnav--align-bottom'
    }
  };
</script>


// WEBPACK FOOTER //
// ../../../../resources/assets/js/app/components/NavBarLinks.vue